<template>
  <div class="pspManagement common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">私海池ID：</div>
          <div class="content">
            <el-input v-model="form.poolId" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">私海池名称：</div>
          <div class="content">
            <el-input v-model="form.poolName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">私海池所属部门：</div>
          <div class="content">
            <el-select v-model="form.deptCode" clearable placeholder="请选择" filterable>
              <el-option
                v-for="(item, index) in expensesTypeList"
                :key="index"
                :label="item.deptName"
                :value="item.deptCode"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <commonTable ref="pspManagementTable" />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { cluePoolManagementApi } from './service';
export default {
  data () {
    return {
      form: {
        type: 2
      },
      expensesTypeList: []
    };
  },
  components: {
    commonTable
  },
  methods: {
    reset () {
      this.form = {
        type: 2
      };
      this.searchBtn();
    },
    searchBtn () {
      this.$refs.pspManagementTable.pageData.pageNum = 1;
      this.$refs.pspManagementTable.getTableData({ url: 'lead/pool-management/lead-list', params: this.form, listKey: 'poolVOList' });
    },
    getDeapList () {
      cluePoolManagementApi.getDepartList().then(res => {
        this.expensesTypeList = res.data;
      });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('私海池ID')
          ._width('10%')
          ._data('poolId')
      );
      tableRow.push(
        new TableColumns()
          ._title('私海池名称')
          ._width('10%')
          ._data('poolName')
      );
      tableRow.push(
        new TableColumns()
          ._title('创建时间')
          ._width('10%')
          ._data('createTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('线索数量')
          ._width('8%')
          ._data('num')
      );
      tableRow.push(
        new TableColumns()
          ._title('所属部门')
          ._width('8%')
          ._data('deptName')
      );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('操作')
      //     ._width('10%')
      //     ._fixed('right')
      //     ._cellType('customDom')
      //     ._cellData({
      //       formater: ({ row, column }) => {
      //         return (
      //           <div>
      //             <el-button type="text" onClick={() => { }}>禁用</el-button>
      //           </div>
      //         );
      //       }
      //     })
      // );
      let column = tableRow._cols();
      this.$refs.pspManagementTable.setColumn(column);
      this.$refs.pspManagementTable.loadTable({ url: 'lead/pool-management/lead-list', params: this.form, listKey: 'poolVOList' });
    }
  },
  mounted () {
    this.loadTable();
    this.getDeapList();
  }
};
</script>

<style scoped>

</style>
